export default "__VITE_ASSET__D_l1DxA$__"